<ng-container *ngIf="receipt as r">
  <details
    #d
    class="gw-bg-background-elevation-2 gw-border-base gw-rounded-2xl gw-gatewee-collapsible-details"
  >
    <summary
      class="gw-flex gw-flex-wrap gw-items-center gw-justify-between gw-gap-small gw-rounded-t-2xl gw-p-medium gw-cursor-pointer gw-list-none gw-select-none gw-outline-none gw-transition-colors gw-duration-300 gw-ease-out hover:gw-bg-background-neutral-1 focus-visible:gw-ring-2 focus-visible:gw-ring-background-accent-1"
    >
      <span class="gw-flex gw-items-center gw-gap-small gw-min-w-0">
        <gatewee-icon
          [icon]="'@tui.receipt'"
          class="gw-shrink-0 gw-text-text-primary"
        ></gatewee-icon>
        <span class="gw-text-base gw-font-semibold gw-text-text-primary">
          {{ 'features.invoices.receipt.title' | translate }}
        </span>
      </span>
      <span
        class="gw-flex gw-min-w-0 gw-max-w-[55%] gw-items-center gw-justify-end gw-gap-2x-small"
      >
        <gatewee-expand-chevron
          [expanded]="d.open"
          class="gw-inline-flex gw-shrink-0 gw-text-text-secondary"
        ></gatewee-expand-chevron>
      </span>
    </summary>
    <div class="gw-gatewee-collapsible-panel">
      <div
        class="gw-gatewee-collapsible-panel-inner gw-border-t gw-border-border-normal gw-px-medium gw-pb-medium gw-pt-medium"
      >
        <gatewee-amount-fee-breakdown
          *ngIf="showAmountBreakdown"
          class="gw-mb-medium"
          [amount]="amount ?? null"
          [calculatedFee]="calculatedFee ?? null"
          [finalAmount]="finalAmount ?? null"
          inputMode="deductFees"
          variant="compact"
        ></gatewee-amount-fee-breakdown>
        <div class="gw-flex gw-flex-col gw-gap-medium gw-min-w-0">
          <div class="gw-min-w-0">
            <p
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-2x-small"
            >
              {{ 'common.paymentReceipt.e2eId' | translate }}
            </p>
            <p
              class="gw-text-base gw-text-text-primary gw-font-mono gw-text-sm gw-break-all"
            >
              {{ r.e2eId || '—' }}
            </p>
          </div>
          <div *ngIf="r.date" class="gw-min-w-0">
            <p
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-2x-small"
            >
              {{ 'common.paymentReceipt.date' | translate }}
            </p>
            <p class="gw-text-base gw-text-text-primary">
              {{ r.date | date : 'dd/MM/yyyy HH:mm' }}
            </p>
          </div>
          <div *ngIf="r.digitableLine" class="gw-min-w-0">
            <p
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-2x-small"
            >
              {{ 'common.paymentReceipt.digitableLine' | translate }}
            </p>
            <p
              class="gw-text-base gw-text-text-primary gw-font-mono gw-text-sm gw-break-all gw-tabular-nums"
            >
              {{ r.digitableLine }}
            </p>
          </div>
        </div>

        <div
          *ngIf="r.payer || r.receiver"
          class="gw-flex gw-gap-small gw-mt-medium gw-min-w-0"
        >
          <div
            *ngIf="r.payer as payer"
            class="gw-flex-1 gw-min-w-0 gw-overflow-hidden gw-p-medium gw-rounded-lg gw-bg-background-elevation-1 gw-border gw-border-border-normal"
          >
            <p
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-small"
            >
              {{ 'common.paymentReceipt.payer' | translate }}
            </p>
            <div class="gw-flex gw-flex-col gw-gap-2x-small gw-min-w-0">
              <p
                class="gw-m-0 gw-text-base gw-text-text-primary gw-break-words"
                *ngIf="payer.holderName"
              >
                {{ payer.holderName }}
              </p>
              <p
                class="gw-m-0 gw-text-sm gw-text-text-secondary gw-break-all"
                *ngIf="payer.holderDocument"
              >
                {{ payer.holderDocument | document : true }}
              </p>
            </div>
          </div>

          <div
            *ngIf="r.receiver as recv"
            class="gw-flex-1 gw-min-w-0 gw-overflow-hidden gw-p-medium gw-rounded-lg gw-bg-background-elevation-1 gw-border gw-border-border-normal"
          >
            <p
              class="gw-text-sm gw-font-medium gw-text-text-secondary gw-mb-small"
            >
              {{ 'common.paymentReceipt.receiver' | translate }}
            </p>
            <div class="gw-flex gw-flex-col gw-gap-2x-small gw-min-w-0">
              <p
                class="gw-m-0 gw-text-base gw-text-text-primary gw-break-words"
                *ngIf="recv.holderName"
              >
                {{ recv.holderName }}
              </p>
              <p
                class="gw-m-0 gw-text-sm gw-text-text-secondary gw-break-words"
                *ngIf="receiverBankDisplayLine"
              >
                {{ receiverBankDisplayLine }}
              </p>
              <div *ngIf="recv.pixKey" class="gw-min-w-0">
                <p
                  class="gw-m-0 gw-text-xs gw-font-medium gw-text-text-tertiary"
                >
                  {{ 'common.paymentReceipt.pixKey' | translate }}
                </p>
                <p
                  class="gw-m-0 gw-text-sm gw-text-text-secondary gw-font-mono gw-break-all"
                >
                  {{ recv.pixKey | pixKey }}
                </p>
              </div>
              <p
                class="gw-m-0 gw-text-sm gw-text-text-secondary gw-break-all"
                *ngIf="recv.holderDocument"
              >
                {{ recv.holderDocument | document : true }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </details>
</ng-container>
